module.exports = __webpack_public_path__ + "static/ogpImage-b7308dff11cc583ad10d8427d7a6a593.png";